import { bus } from "@/main";

export const multipleObjectsTableMixin = {
  data() {
    return {
      objects: [],
      selectedIndexes: [],
      lastItemClicked: undefined
    };
  },

  methods: {
    /**
     * Determines if the user if making a simple select or a bulk select and executes the correct action.
     * @param {Number} index - index of the object clicked
     * @param {Object} e - information about the click event
     */
    select(index, e) {
      if (e.shiftKey) {
        this.bulkSelect(index);
      } else {
        this.toggleObject(index);
      }
      this.lastItemClicked = index;
    },

    /**
     * Allows selecting a group of items in bulk.
     * @param index - index of the last clicked item.
     */
    bulkSelect(index) {
      let previousClick = 0;
      let firstItem;
      let lastItem;
      if (this.lastItemClicked !== undefined) {
        previousClick = this.lastItemClicked;
      }
      if (previousClick === index) {
        this.toggleObject(index);
      } else {
        if (previousClick < index) {
          firstItem = previousClick;
          lastItem = index;
        } else if (previousClick > index) {
          firstItem = index;
          lastItem = previousClick;
        }
        for (let i = firstItem; i <= lastItem; i++) {
          if (!this.selectedIndexes.includes(i)) {
            this.selectedIndexes.push(i);
            if (this.canHighlightObjects) {
              this.highlightObject(i);
            }
          }
        }
      }
    },

    highlightObject(index) {
      let geoJson = this.getGeoJson(index);
      let uuid = this.getUuid(index);
      if (geoJson) {
        bus.$emit("highlight-object-from-selected-table", {
          geoJson: geoJson,
          uuid: uuid
        });
      }
    },

    /**
     * Adds or removes an object index from the selected list
     * @param {number} index -  index of the object in the objects list
     */
    toggleObject(index) {
      let selectedIndex = this.selectedIndexes.findIndex(
        selected => selected === index
      );
      let objectWasSelected = selectedIndex !== -1;

      if (objectWasSelected) {
        this.selectedIndexes.splice(selectedIndex, 1);
      } else {
        this.selectedIndexes.push(index);
      }

      if (this.canHighlightObjects) {
        this.toggleObjectHighlight(index, objectWasSelected);
      }
    },

    toggleObjectHighlight(index, objectWasSelected) {
      let geoJson = this.getGeoJson(index);
      let uuid = this.getUuid(index);

      if (uuid) {
        if (objectWasSelected) {
          bus.$emit("remove-highlight-from-selected-table", uuid);
        } else if (geoJson) {
          bus.$emit("highlight-object-from-selected-table", {
            geoJson: geoJson,
            uuid: uuid
          });
        }
      }
    },

    /**
     * Adds all objects to the selected list.
     */
    selectAll() {
      this.clearSelection();
      let nrOfObjects = this.objects.length;
      for (let i = 0; i < nrOfObjects; i++) {
        this.selectedIndexes.push(i);
        if (this.canHighlightObjects) {
          this.highlightObject(i);
        }
      }
    },

    /**
     * Inverts the selection, i.e. adds the previously non-selected objects to the list and removes the previously
     * selected from the list.
     */
    invertSelection() {
      let nrOfObjects = this.objects.length;
      for (let i = 0; i < nrOfObjects; i++) {
        this.toggleObject(i);
      }
    },

    /**
     * Removes all objects from the selected list.
     */
    clearSelection() {
      this.selectedIndexes = [];
      if (this.canHighlightObjects) {
        bus.$emit("remove-highlight-from-selected-table");
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/forms/multipleObjectsSelection/multipleObjectsTableMixin.js